import Alpine from "alpinejs"

Alpine.data("search", () => ({
    // Search Input
    isFocused: false,

    // available states
    state: {
        active: false, // true if anything but closed
        searching: false, // true if searching without setting other states to false

        closed: true,
        open: false,
        result: false,
        empty: false,
    },

    // user input
    searchTerm: "",

    // async search result
    result: {
        total: 0,
        featuredItem: [],
        items: [],
        alternativeResults: null,
    },

    searchDebounceTimer: null,

    init() {
        this.$watch("searchTerm", () => {
            if (this.searchTerm.length > 0) {
                this.setState("searching")

                const debounceSearch = (func, delay) => {
                    return () => {
                        const context = this
                        const args = arguments
                        clearTimeout(this.searchDebounceTimer)
                        this.searchDebounceTimer = setTimeout(() => func.apply(context, args), delay)
                    }
                }

                debounceSearch(() => {
                    this.search()
                }, 500)()
            }
        })
    },

    setState(newState) {
        // check if newState does exist in this.state
        if (!Object.keys(this.state).includes(newState)) {
            return false
        }

        // reset all states
        if (newState !== "searching") {
            Object.keys(this.state).forEach((key) => {
                if (key === newState || key === "active" || key === "searching") {
                    return
                }
                this.state[key] = false
            })
        }

        // set new state
        this.state[newState] = true

        // check if we should show the result state instead
        if (newState === "open" || newState === "searching") {
            this.isFocused = true
            this.state["active"] = true
            document.body.classList.add("overflow-hidden")
            document.querySelector("main").setAttribute("inert", true)
            if (this.searchTerm && this.result.total) {
                this.setState("result")
            }
        } else if (newState === "closed") {
            this.isFocused = false
            this.searchTerm = ""
            this.state["active"] = false
            document.body.classList.remove("overflow-hidden")
            document.querySelector("main").removeAttribute("inert", false)
        }

        if (this.state.active) {
            this.$dispatch("nav-search-active-state", this.state.active)
        } else {
            // deactivate delayed to let closing animation finish
            setTimeout(() => {
                this.$dispatch("nav-search-active-state", this.state.active)
            }, 300)
        }

        return true
    },

    clearSearch() {
        this.searchTerm = ""
        this.isFocused = true
    },

    search() {
        if (document.body.classList.contains("preview-body") && this.$root.dataset.dummyresult) {
            this.dummyQuery()
        } else {
            this.query()
        }
    },

    dummyQuery() {
        setTimeout(() => {
            if (this.searchTerm.length > 5) {
                let result = []
                try {
                    result = JSON.parse(this.$root.dataset.dummyresult)
                } catch (e) {
                    // ignore...
                }

                this.result = result
                this.setState("result")
            } else {
                this.result = {
                    total: 0,
                    items: [],
                    alternativeResults: {
                        subItems: {
                            "00": { label: "Example term 1", href: "#" },
                            "01": { label: "Example term 2", href: "#" },
                        },
                    },
                }
                this.setState("empty")
            }

            this.state["searching"] = false
        }, 500)
    },

    async query() {
        try {
            // dataset.uri may already carry its own query string (e.g.
            // entryPoint/excludeEntryPoint), so merge into it via URL/
            // URLSearchParams instead of blindly appending a new "?".
            const url = new URL(this.$root.dataset.uri, window.location.origin)
            url.searchParams.set("q", this.searchTerm)
            url.searchParams.set("perPage", 5)
            const response = await fetch(url)
            this.result = await response.json()

            if (this.result.total > 0) {
                this.setState("result")
            } else {
                this.setState("empty")
            }
        } catch (error) {
            this.setState("empty")
        }

        this.state["searching"] = false
    },

    triggerFullSearch(clickEvent) {
        const url = new URL(clickEvent.target.href)
        url.searchParams.set("q", this.searchTerm)
        window.location.href = url.toString()
    },
}))
